import React from "react";
import { Grid, Container } from "@material-ui/core";
import { useStyles } from "./style";
import Post from "../../components/post/justin";
import NewsLetter from "../../components/newsletter/sidebar";

export default function JustIn({ data }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.vglJustInner}>
          <Grid container spacing={1}>
            <Grid item sm={12} md={8} lg={8} xl={8}>
              <div className={classes.vglJustInLeftColumn}>
                <div className={classes.vglJustInPostsContainer}>
                  <h2 className={classes.vglJustInHeading}>
                    This Just In{" "}
                    <img
                      draggable="false"
                      className={classes.vglImgEmoji}
                      alt="⚡️"
                      src="https://s.w.org/images/core/emoji/13.0.1/svg/26a1.svg"
                    />
                  </h2>
                  <div>
                    {data.map(({ node }, i) => (
                      <Post post={node} key={i}/>
                    ))}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} md={4} lg={4} xl={4}>
              <div className={`${classes.vglStickyAds} ${classes.vglSticky}`}>
                <div className={classes.vglColumnInner}>
                  <div style={{ marginBottom: 35 }}>
                    <NewsLetter />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
